import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { Peer, PeerPerfil } from '../../common/peer';
import { IPeerMonitor } from '../../common/monitor';
import { HeaderService } from './header.service';
import { IDBResponse } from '../../common/responses';

@Injectable()
export class PeerService {
    
    constructor(private $http: Http, private $headers: HeaderService){
        
    }
    
    getPeer(usuario: string): Observable<Peer[]> {
        return this.$http.get(this.$headers.getApi() + '/peer/' + usuario, { headers: this.$headers.getHeaders() })
            .map(res => res.json())
            .catch((err: Response) => Observable.throw(err.json()));
    }
    
    getPeers(): Observable<Peer[]> {
        return this.$http.get(this.$headers.getApi() + '/peers', { headers: this.$headers.getHeaders() })
            .map(res => res.json())
            .catch((err: Response) => Observable.throw(err.json()));
    }
    
    /**
     * Funciones de edicion, creación y eliminacion de peers
     */
    updatePeer(data: { peer: Peer, update: boolean }): Observable<IDBResponse> {
        let http$: Observable<Response>;
        if (data.update === undefined)
            http$ = this.$http.delete(this.$headers.getApi() + '/peer/' + data.peer.usuario, { headers: this.$headers.getHeaders() })
        else if (data.update)
            http$ = this.$http.post(this.$headers.getApi() + '/peer', data.peer, { headers: this.$headers.getHeaders() })
        else
            http$ = this.$http.put(this.$headers.getApi() + '/peer', data.peer, { headers: this.$headers.getHeaders() })
        
        return http$.map(res => res.json())
            .catch((err: Response) => Observable.throw(err.json()));
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/_services/peer.service.ts